__turbopack_context__.v({
  "applicationLoader": "LandingForm-module-scss-module__PhMV6W__applicationLoader",
  "authorization": "LandingForm-module-scss-module__PhMV6W__authorization",
  "checkboxWrapper": "LandingForm-module-scss-module__PhMV6W__checkboxWrapper",
  "commonMargins": "LandingForm-module-scss-module__PhMV6W__commonMargins",
  "customBackground": "LandingForm-module-scss-module__PhMV6W__customBackground",
  "emailContainer": "LandingForm-module-scss-module__PhMV6W__emailContainer",
  "error": "LandingForm-module-scss-module__PhMV6W__error",
  "errorMessage": "LandingForm-module-scss-module__PhMV6W__errorMessage",
  "formHeading": "LandingForm-module-scss-module__PhMV6W__formHeading",
  "greyBackground": "LandingForm-module-scss-module__PhMV6W__greyBackground",
  "inputWrapper": "LandingForm-module-scss-module__PhMV6W__inputWrapper",
  "newLeadFormEmail": "LandingForm-module-scss-module__PhMV6W__newLeadFormEmail",
  "newLeadFormEmailFullWidth": "LandingForm-module-scss-module__PhMV6W__newLeadFormEmailFullWidth",
  "newLeadFormFirstName": "LandingForm-module-scss-module__PhMV6W__newLeadFormFirstName",
  "newLeadFormPhone": "LandingForm-module-scss-module__PhMV6W__newLeadFormPhone",
  "newLeadFormWrapper": "LandingForm-module-scss-module__PhMV6W__newLeadFormWrapper",
  "root": "LandingForm-module-scss-module__PhMV6W__root",
  "whiteBackground": "LandingForm-module-scss-module__PhMV6W__whiteBackground",
  "widthInputbox": "LandingForm-module-scss-module__PhMV6W__widthInputbox",
  "widthInputboxFirstName": "LandingForm-module-scss-module__PhMV6W__widthInputboxFirstName",
});
